<ng-container *ngIf="salesText">
  <div [ngClass]="cssClass + '__salesTxt-div'">
    <span class="fas fa-info-circle"></span>
    <div [ngClass]="cssClass + '__salesTxt-content'" [innerHTML]="salesText"></div>
  </div>
</ng-container>
